import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { env } from '@amfam/environment';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class GlobalHeadersInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modified = request.clone({
      headers:
        request.headers.get('afe-source-id') === 'MyAccount'
          ? this.addTokenHeaders(request.headers, request.method)
          : this.addGlobalHeaders(request.headers, request.method),
      withCredentials: true
    });
    return next.handle(modified);
  }

  private addTokenHeaders(headers: HttpHeaders, method: string): HttpHeaders {
    if (!headers.has('authorization')) {
      let tokens;
      if (env.environment === 'prod') {
        tokens =
          localStorage.getItem('FR-SDK-AFI-MyAccount-Web') != null
            ? localStorage.getItem('FR-SDK-AFI-MyAccount-Web')
            : '';
      } else {
        tokens =
          localStorage.getItem('FR-SDK-AFI-MyAccount-Web-Preprod') != null
            ? localStorage.getItem('FR-SDK-AFI-MyAccount-Web-Preprod')
            : '';
      }

      if (tokens.length > 0) {
        const json = JSON.parse(tokens);

        headers = headers.set('authorization', 'Bearer ' + json.accessToken);
      }
    }

    if (!headers.has('afe-trace-id')) {
      headers = headers.set('afe-trace-id', crypto.randomUUID());
    }

    return headers;
  }

  private addGlobalHeaders(headers: HttpHeaders, method: string): HttpHeaders {
    if (!headers.has('accept')) {
      headers = headers.set('accept', 'application/json');
    }
    if (!headers.has('afi-appname')) {
      headers = headers.set('afi-appname', 'MyAccountWebApplication');
    }
    if (!headers.has('content-type')) {
      headers = headers.set('content-type', 'application/json');
    }
    if (!headers.has('afi-api-key')) {
      headers = headers.set('afi-api-key', env.afiApiKey);
    }
    if (method === 'GET') {
      if (!headers.has('cache-control')) {
        headers = headers.set('cache-control', 'no-cache');
      }
      if (!headers.has('pragma')) {
        headers = headers.set('pragma', 'no-cache');
      }
    }
    if (!headers.has('afe-trace-id')) {
      headers = headers.set('afe-trace-id', crypto.randomUUID());
    }
    if (!headers.has('afe-source-id')) {
      headers = headers.set('afe-source-id', 'AFI_MyAccount');
    }

    if (!headers.has('authorization')) {
      let tokens;
      if (env.environment === 'prod') {
        tokens =
          localStorage.getItem('FR-SDK-AFI-MyAccount-Web') != null
            ? localStorage.getItem('FR-SDK-AFI-MyAccount-Web')
            : '';
      } else {
        tokens =
          localStorage.getItem('FR-SDK-AFI-MyAccount-Web-Preprod') != null
            ? localStorage.getItem('FR-SDK-AFI-MyAccount-Web-Preprod')
            : '';
      }

      if (tokens.length > 0) {
        const json = JSON.parse(tokens);

        headers = headers.set('authorization', 'Bearer ' + json.accessToken);
      }
    }

    if (env.environment === 'int01' || env.environment === 'int03') {
      headers = headers.set('afe-env-target', env.leg);
    }

    return headers;
  }
}
